import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><strong parentName="p">{`If you are near 5/24, it might be worth waiting`}</strong>{` until you are under 5/24 again, instead of grabbing a ton of new cards immediately. `}<strong parentName="p">{`It's up to you how long a wait is worth it`}</strong>{` - personally, I would definitely wait at least a few months - maybe even several, since you can grab many biz cards while waiting.`}</p>
    <p>{`You might decide to (regularly?) check in a Chase branch for any `}<strong parentName="p">{`Chase CC preapprovals - these get around the 5/24 rule `}</strong>{`(but do not appear to get around the "one Sapphire" bonus rule).`}</p>
    <p>{`Amex sends out `}<strong parentName="p">{`targeted mailers / emails / Amex offers that don't have the once-per-lifetime limitation`}</strong>{`.`}</p>
    <p>{`The optimal time to get the SW cards is so that `}<strong parentName="p">{`all bonuses `}</strong>{`post in Jan/Feb, giving you the CP for almost 2 years.`}</p>
    <p>{`Some of the premium cards (Amex Platinum, Amex PRG, Citi Prestige, Ritz, CNB Crystal Visa, etc.) offer calendar-year airline/travel credits - if you apply at just the right time (usually late Nov.-ish / early Dec.-ish, depending), `}<strong parentName="p">{`you can triple-dip the credit`}</strong>{` in your first card year before downgrading/canceling.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      